export default "__VITE_PUBLIC_ASSET__8fbbb6e7__"